export const shouldOpenLinkInNewWindow = (
    resultsClass: string | undefined,
    fileType: string | undefined
): boolean => {
    const type = fileType?.trim();
    return (
        resultsClass === "planningResourceLibrary" &&
        (type === "PDF File" || type === "Video")
    );
};
